module.exports = __webpack_public_path__ + "static/media/EventPhone-Icon.99e7aa13.svg";